// The error envelope the SCHOOLFEE routes return, distinct from the legacy
// `ErrorResponse` the rest of the portal receives. It is ProblemError in the
// v1 format — the shape is new, the format version is not.
export type ProblemErrorDetail = Record<string, unknown>;

export type ProblemError = {
  code: string;
  message: string;
  message_fr?: string;
  correlation_id?: string;
  // Field-level diagnostic material. Never rendered (D-23) — it is kept on the
  // type so it can be logged, and painting it would bind the portal to server
  // field naming.
  details?: ProblemErrorDetail[];
};

// Both envelopes arrive on the same path, so the two have to be told apart
// exactly: only this one carries a `code`.
export const isProblemError = (data: unknown): data is ProblemError => {
  if (typeof data !== "object" || data === null) return false;

  const candidate = data as Record<string, unknown>;

  return (
    typeof candidate.code === "string" && typeof candidate.message === "string"
  );
};
